import React from 'react';
import { BentoProvider } from '@prezi/bento';
import App from './App';
import PageRouter from './Router';
import { init as initFeatures, haveFeaturesBeenInitialized } from '../../featureswitches/Features';
export default (props => {
  if (!haveFeaturesBeenInitialized()) {
    initFeatures(props.evaluatedFeatures);
  }
  return React.createElement(BentoProvider, null, React.createElement(App, props, React.createElement(PageRouter, null)));
});